import { Component, OnInit, ElementRef, ViewChild, OnDestroy } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { HttpClient } from "@angular/common/http";
import * as supersetEmbedded from "@superset-ui/embedded-sdk";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { AppData } from "../../helpers/app-data";

@Component({
  selector: "app-superset-report",
  templateUrl: "./superset-report.component.html",
  styleUrl: "./superset-report.component.css",
})
export class SupersetReportComponent implements OnInit, OnDestroy {
  @ViewChild("dashboardContainer", { static: true }) dashboardContainer!: ElementRef;

  public isLoading: boolean = false;
  public errorMessage: string | null = null;
  
  private currentEmbed: any = null; 
  private destroy$ = new Subject<void>();

  constructor(
    private route: ActivatedRoute,
    private http: HttpClient
  ) {}

  ngOnInit(): void {
    this.route.params
      .pipe(takeUntil(this.destroy$))
      .subscribe((params) => {
        const reportKey = params["reportKey"];
        if (reportKey) {
          this.loadReport(reportKey);
        }
      });
  }

  
  private async loadReport(reportKey: string): Promise<void> {
    this.isLoading = true;
    this.errorMessage = null;

    if (this.currentEmbed) {
      this.dashboardContainer.nativeElement.innerHTML = "";
      this.currentEmbed = null;
    }

    const tokenUrl = AppData.API_URL + ["Superset", `reports/${reportKey}/token`].join("/");
    // Tipado de la respuesta esperada del backend con las dos propiedades necesarias
    this.http.get<{ token: string, dashboardId: string, supersetDomain: string }>(tokenUrl).subscribe({
      next: (response) => {
        const tokenVal = response.token;
        const dashboardIdVal = response.dashboardId;
        const domainVal = response.supersetDomain;

        if (!response || !tokenVal || !dashboardIdVal || !domainVal) {
          this.handleError("La API de reportes devolvió parámetros insuficientes.");
          return;
        }

        supersetEmbedded.embedDashboard({
          id: dashboardIdVal,
          supersetDomain: domainVal,
          mountPoint: this.dashboardContainer.nativeElement,
          fetchGuestToken: () => Promise.resolve(tokenVal), 
          dashboardUiConfig: {
            hideTitle: false, // Muestra la barra superior global (Exportar PDF/Dashboard)
            hideChartControls: false // Oculta los 3 puntos individuales por gráfico
          }
        }).then((result: any) => {
          this.currentEmbed = result;
          this.isLoading = false;
        }).catch((err: any) => {
          console.error("Error SDK:", err);
          this.handleError("Error al inicializar el contenedor gráfico del reporte.");
        });
      },
      error: (err) => {
        console.error("Error Token:", err);
        this.handleError("No se pudieron validar los permisos para visualizar este reporte.");
      }
    });
  }

  private handleError(message: string): void {
    this.errorMessage = message;
    this.isLoading = false;
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}